import PropTypes from "prop-types";
import SVG from "theme/components/icons/base/SVG";

const BasketIcon = ({ color, width, height, viewBox, ...rest }) => (
    <SVG width={width} height={height} viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
        <title>Basket Icon</title>
        <g stroke={color} strokeWidth=".8">
            <path d="M.4 2.9h15.2v13.2H.4zM5.73.9h4.53v1.87H5.73z" />
        </g>
    </SVG>
);

BasketIcon.propTypes = {
    color: PropTypes.string,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    viewBox: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
};

BasketIcon.defaultProps = {
    color: "#000",
    height: "17px",
    viewBox: "0 0 16 17",
    width: "16px",
};

export default BasketIcon;
